import React from 'react'
import { useField } from 'react-final-form'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'

import Icon from '~/truck/icon'

const StyledPreviewContainer = styled.div`
  align-items: center;
  background: ${props => props.theme.palette.grayscale30};
  border: 1px dashed ${props => props.theme.colors.gray};
  display: flex;
  flex-direction: row;
  height: ${props => props.theme.spacing.cozy * 5}px;
  margin: ${props => props.theme.spacing.comfortable}px 0;
  padding: ${props => props.theme.spacing.cozy}px;
  width: 50%;

  ${down('sm')} {
    min-width: 100%;
  }

  > svg {
    height: 11.64px;
    width: 11.64px;
  }
`

function AttachedFilePreview() {
  const { input } = useField('fileAttachment')

  return (
    input.value && (
      <StyledPreviewContainer>
        <span className="text-xs text-tertiary">{input.value.name}</span>
        <Icon
          color="grayscale60"
          type="close"
          onClick={() => {
            input.onChange(null)
          }}
        />
      </StyledPreviewContainer>
    )
  )
}

export default AttachedFilePreview
